import { HttpClient } from "@angular/common/http";
import { TranslateService } from '@ngx-translate/core';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from "rxjs";

import { BaseController } from "../base.controller";
import { AlertService } from "../../services/alert/alert.service";
import { LoadingService } from "../../services/loading/loading.service";
import { PhoneLanguageDto } from '../../../src/dtos/phonelanguage/PhoneLanguageDto';
import { Languages } from "@shared/src/public-api";

@Injectable({
    providedIn: 'root',
})
export class PhoneLanguageController extends BaseController {
    private base = '/phonelanguage';

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        protected router: Router,
        @Inject('LoadingService') protected loadingService: LoadingService) {
        super(http, alertService, translateService, loadingService, router);
    }

    /**
     * Obtiene el idioma asociado a un número de teléfono
     */
    public getLanguageByPhone(phone: string): Observable<Languages> {
        return this.get(this.base + "/language/" + phone);
    }

    /**
     * Guarda o actualiza un PhoneLanguage
     */
    public save(phoneLanguage: PhoneLanguageDto): Observable<PhoneLanguageDto> {
        return this.postBusy(this.base + "/save", phoneLanguage, "savePhoneLanguage");
    }
}
